import { z } from 'zod';
import { addressSourceSchema, latitude, longitude } from './common.js';
import { zoneBrief } from './zone.js';
/**
 * Адреса клиента. Координаты обязательны: без них нельзя определить зону.
 * Текстовые детали (подъезд, этаж, квартира) вводятся всегда — их нет
 * ни в каких координатах, а курьеру без них не дойти.
 */
export const address = z.object({
    id: z.number().int().positive(),
    label: z.string().nullable(),
    lat: latitude,
    lon: longitude,
    source: addressSourceSchema,
    address_text: z.string(),
    house: z.string().nullable(),
    entrance: z.string().nullable(),
    floor: z.string().nullable(),
    apartment: z.string().nullable(),
    landmark: z.string().nullable(),
    is_default: z.boolean(),
    zone: zoneBrief.nullable(),
});
export const createAddressBody = z.object({
    label: z.string().max(64).nullable().optional(),
    lat: latitude,
    lon: longitude,
    source: addressSourceSchema,
    address_text: z.string().min(1).max(500),
    house: z.string().max(50).nullable().optional(),
    entrance: z.string().max(50).nullable().optional(),
    floor: z.string().max(50).nullable().optional(),
    apartment: z.string().max(50).nullable().optional(),
    landmark: z.string().max(200).nullable().optional(),
    is_default: z.boolean().default(false),
});
export const updateAddressBody = createAddressBody.partial();
/**
 * Последняя точка, присланная боту кнопкой геолокации в чате — второй канал
 * из ADR-0003. `null`, если пользователь ничего не присылал.
 * Актуальность (не старше нескольких минут) проверяет клиент по `received_at`.
 */
export const lastLocationResponse = z
    .object({
    lat: latitude,
    lon: longitude,
    received_at: z.string(),
})
    .nullable();
//# sourceMappingURL=address.js.map